module.exports = __webpack_public_path__ + "static/media/answer_img2.83157626.png";